import TablePagination from '../../components/tablePagination/index.vue'
import { parseTime } from '../../libs/utils/parseTime'
import { trim } from '../../libs/utils/paramTrim'

export default {
  components: {
    TablePagination
  },
  data() {
    return {
      tableData: { }, // 表格数据缓存
      selection: [], // 已选表格数据缓存
      tableRadio: -1,
      pagination: { // 表格分页初始化信息
        currentPage: 1,
        pageSize: 50,
        pageSizes: [5, 10, 20, 50],
        layout: 'slot, total, sizes, ->, prev, pager, next, jumper'
      }
    }
  },
  methods: {
    rowClick(row) {
      this.$refs.table.toggleRowSelection(row)
      this.handleMultipleRadio(row)
    },
    handleMultipleRadio(row) { // 处理单选和复选
      // 设置单选按钮选中的第几行数据
      const { service } = this.$refs.table
      if (service) {
        this.tableRadio = this.tableData.data.indexOf(row)
      } else {
        this.tableRadio = this.tableData.indexOf(row)
      }

      if (!this.isCheckbox) { // 单选按钮，将selection的值设置为选中行
        this.selection = [row]
      }
    },
    // selectionChange(selection) {
    //   this.selection = selection
    // },
    handleService(param) { // 分页切换分页时候触发
      this.handleSearch(this.searchUrl, { ...this.formData, ...param })
    },
    handleSearch(url, param) {
      this.selection.length = 0 // 清空 this.selection
      this.loadingSearch = true // 禁用查询按钮
      this.tableLoading = true
      // console.log('isCheckbox', this.isCheckbox)
      // 对查询的条件数据去除两边空格
      if (param && param.data) {
        const searchParam = param.data
        trim(searchParam, param.data)
      }

      return new Promise((resolve, reject) => {
        this.$http.post(url, param)
          .then(res => {
            // 表单遮罩层, 查询按钮loading
            this.loadingSearch = false
            this.tableLoading = false
            this.tableRadio = -1 // 重置单选按钮选中位置
            if (!res.data) {
              return
            }
            if (res.data && res.data.code !== 1) { // 请求失败
              this.$notify.error({
                title: '错误',
                message: '查询列表数据失败！'
              })
              reject()
              return
            }
            if (this.handleSearchAfter) {
              this.tableData = this.handleSearchAfter(res.data.data)
            } else {
              this.tableData = res.data.data // 设置table数据
            }
            resolve(this.tableData.data)
          }).catch(() => {
            this.loadingSearch = false
            this.tableLoading = false
            reject()
          })
      })
    },
    formatterTime(row, column, cellValue) {
      if (cellValue) return parseTime(cellValue)
      return cellValue
    }
  }
}
